import { Box, Flex, Grid, Heading, Text } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDownlineListApi } from '../api/query/downlineApi';
import DownlineCard from '../components/downline/DownlineCard';
import ImgComp from '../utils/ImgComp';

const DownlineScreen = () => {
	const navigate = useNavigate();
	//* api
	const getDownlineList = useQuery(['getDownlineListApi'], getDownlineListApi);
	useEffect(() => {
		if (sessionStorage.getItem('isThirdPartyLogin') === 'true') {
			navigate('/pcso');
		}
	}, []);

	return (
		<Box
			width='100%'
			paddingX={['3', '3', '5', '5', '10']}
			paddingTop={['80px', '80px', '80px', '80px', '30px', '30px', '30px']}
			paddingBottom={['80px']}
			minHeight='100vh'
		>
			<Flex marginTop='48px' justifyContent='space-between' flexDirection='column'>
				<Heading
					fontSize={['20px', '20px', '20px', '20px', '20px', '32px']}
					alignSelf='center'
					width='100%'
					textAlign='left'
					paddingBottom='20px'
				>
					Downline List
				</Heading>

				<Flex backgroundColor='white' padding={5} borderRadius={8} flexDirection='column'>
					<Box onClick={() => navigate('/profile')} cursor='pointer' width={10}>
						<ImgComp svgName='left-arrow' />
					</Box>
					{getDownlineList.data !== undefined && getDownlineList.data?.length !== 0 ? (
						<Grid
							templateColumns={[
								'repeat(1, 1fr)',
								'repeat(1, 1fr)',
								'repeat(2, 1fr)',
								'repeat(2, 1fr)',
								'repeat(2, 1fr)',
								'repeat(3, 1fr)',
							]}
							alignItems='center'
							justifyContent='center'
							paddingLeft={['0', '0', '2%']}
							gap={3}
						>
							{getDownlineList.data?.map((items) => {
								return (
									<DownlineCard
										key={items.id}
										downlineName={items.userName}
										mobileNo={items.mobileNumber}
										creditLimit={items.creditLimit}
										balanceCredit={items.remainCredit}
										totalCommision={items.refGameTypeCommissionDto[0]?.commissionRate}
										downlineCode={items.userCode}
										onClick={() => {
											navigate('/profile/downlineProfile');
											sessionStorage.setItem('downlineId', items.id);
											sessionStorage.setItem('downlineCode', items.userCode);
											sessionStorage.setItem('downlineName', items.userName);
											sessionStorage.setItem('downlineMobileNo', items.mobileNumber);
										}}
										isAgent={items.isAgent}
									/>
								);
							})}
						</Grid>
					) : (
						<Flex
							justifyContent='center'
							alignItems='center'
							minHeight={['55vh', '', '', '', '70vh']}
						>
							<Text>No downline yet.</Text>
						</Flex>
					)}
				</Flex>
			</Flex>
		</Box>
	);
};

export default DownlineScreen;
